/** 
 * Dada la gravedad de un evento, obtiene el color para un texto claro sobre el
 * fondo oscuro de un tooltip.
 * 
 * @param {number} gravedad La gravedad de un evento.
 * @returns {string | undefined} El nuevo color de un texto claro sobre fondo
 * oscuro. Si es undefined, se usa el color por defecto.
 */
export function getLightTextIssueColor(gravedad: number): string | undefined {
  switch (gravedad) {
    case 1: return "hsl(40, 75%, 70%)";
    case 2: return "hsl(0, 75%, 75%)";
    default: return undefined;
  }
}

/** 
 * Dada la gravedad de un evento, obtiene el color para un texto oscuro sobre
 * fondo claro.
 * 
 * @param {number} gravedad La gravedad de un evento.
 * @returns {string | undefined} El nuevo color de un texto oscuro sobre fondo
 * claro. Si es undefined, se usa el color por defecto.
 */
export function getDarkTextIssueColor(gravedad: number): string | undefined {
  switch (gravedad) {
    case 1: return "hsl(40, 75%, 50%)";
    case 2: return "hsl(0, 75%, 50%)";
    default: return undefined;
  }
}

/** 
 * Dada la gravedad de un evento, obtiene el color para un marcador en el
 * gráfico.
 * 
 * @param {number} gravedad La gravedad de un evento.
 * @returns {string} El nuevo color de un marcador en el gráfico.
 */
export function getIssuePlotColor(gravedad: number): string {
  switch (gravedad) {
    case 1: return "hsl(40, 60%, 60%)";
    case 2: return "hsl(0, 60%, 60%)";
    default: return "hsl(140, 60%, 40%)";
  }
}